module.exports = __webpack_public_path__ + "img/birdslife_bottomimage4.aff38993.jpg";